import { Injectable } from '@angular/core';
import { EstrategiasReportes, ServicioReportes } from '../core/servicio-reportes';
import { ReporteRegistrado } from '../core/reporte';
import { ReportesApiService } from '../reportes-api.services';
import { DIRECCION_TRABAJO_REPORTES_DATOS, FormatoReporteDireccionTrabajo } from './tipos-reporte';

@Injectable({ providedIn: 'root' })
export class DireccionTrabajoReportesService extends ServicioReportes<'DIRECCIONTRABAJO', typeof DIRECCION_TRABAJO_REPORTES_DATOS> {
    constructor(private readonly api: ReportesApiService) {
        const estrategias = {
            moraPrev: {
                consultar: ({ idcliente }) => api.obtenerMoraPrev(idcliente),
                transformar: (dto) => ({ data: dto }),
            },
            lre: {
                consultar: ({ idcliente, anio }) => api.obtenerLreAnual(idcliente, anio),
                transformar: (dto) => ({ data: dto })
            }
        } satisfies EstrategiasReportes<typeof DIRECCION_TRABAJO_REPORTES_DATOS>;

        super(
            {
                codigo: 'DIRECCIONTRABAJO',
                nombre: 'Dirección del Trabajo',
                ruta: '/direccion-trabajo-reportes',
                icono: 'pi pi-briefcase',
                permiso: 'reportes.ver',
                actualizacionMasiva: true
            },
            DIRECCION_TRABAJO_REPORTES_DATOS,
            estrategias
        );
    }

}

export type ReporteDireccionTrabajo = ReporteRegistrado<FormatoReporteDireccionTrabajo>;
